<template>
    <div class="page-container">
        <div class="container" style="position: relative;">
            <h3 class="blue-bg page-title">لیست کاربران برتر باشگاه مشتریان</h3>

            <div class="users" v-if="!errorMessage && !loader">
                <div v-if="items.length != 0">
                    <div v-bind:class="{'blue-bg' : user.UserId == item.UserId}" class="card"
                        v-for="(item, index) in items" :key="item.UserId">
                        <span class="index" v-bind:class="{'blue-text' : user.UserId != item.UserId}">{{ index + 1 |
                        persian }}</span>
                        <span class="name">
                            <img v-if="index == 0" class="img" alt="نفر اول" title="بارکد کارت خودرو جدید"
                                src="../../assets/img/crown.png" />
                            <img v-if="index == 1" class="img" alt="نفر اول" title="بارکد کارت خودرو جدید"
                                src="../../assets/img/star.png" />

                            <span v-if="item.FirstName || item.LastName">
                                {{ item.FirstName }} {{ item.LastName }}
                            </span>

                            <span v-if="!item.FirstName && !item.LastName">
                                {{ item.MobileNumber }}
                            </span>

                            <img v-if="index == 0 || index == 1" class="img" alt="نفر اول" title="بارکد کارت خودرو جدید"
                                src="../../assets/img/gift.png" />

                        </span>
                        <span class="count" v-bind:class="{'blue-text' : user.UserId != item.UserId}">{{ item.Count |
                        persian }} دعوت</span>
                    </div>
                    <br>
                    <br>
                    <slot v-if="user!=null">
                        <div class="blue-text mar5b" v-if="!isUserInTopUsers">
                            جایگاه این ماه شما :
                        </div>
                        <div class="card blue-bg" v-if="!isUserInTopUsers">
                            <span class="index">{{ user.CurrentRow | persian }}</span>
                            <span class="name">
                                {{ user.FirstName }} {{ user.LastName }}
                            </span>
                            <span class="count">{{ user.CurrentCount | persian }} دعوت</span>
                        </div>
                        <div class="blue-text mar5b" v-if="!isUserInTopUsers">
                            جایگاه کلی :
                        </div>
                        <div class="card blue-bg " v-if="!isUserInTopUsers">
                            <span class="index">{{ user.TotalRow | persian }}</span>
                            <span class="name">
                                {{ user.FirstName }} {{ user.LastName }}
                            </span>
                            <span class="count">{{ user.TotalCount | persian }} دعوت</span>
                        </div>
                    </slot>

                </div>
            </div>
            <div class="error-message" v-if="!loader && errorMessage">{{ errorMessage }}</div>
            <div class="loader" v-if="loader">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import api from "../../service";
import { mapActions } from "vuex";

export default {
    name: "top-users",
    props: {},
    data() {
        return {
            totalRetry: 0,
            errorMessage: null,
            loader: false,
            items: [],
            user: {}
        };
    },
    computed: {
        isUserInTopUsers: function () {
            if (this.items && this.items.length > 0) {
                for (let i = 0; i < this.items.length; i++) {
                    const element = this.items[i];
                    if (element.UserId == this.user.UserId) {
                        return true;
                    }
                }
            }
            return false;
        }
    },
    methods: {
        ...mapActions(["setTheme", "setToken"]),
        loadData() {
            this.loading = true;
            api.getTopUsers().then((response) => {
                if (response.data && response.data.Status === 200) {
                    this.items = response.data.Data.Items;
                    this.user = response.data.Data.User;
                    this.totalRetry = 0;
                } else {
                    if (response.data && response.data.Messages && response.data.Messages.length > 0) {
                        this.errorMessage = response.data.Messages[0];
                    }
                }
            })
                .catch(() => {
                    if (this.totalRetry < 3) {
                        this.loadData();
                        this.totalRetry++;
                    }
                    this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
                })
                .finally(() => {
                    this.loading = false;
                    this.errorMessage = "";

                });
        }
    },
    mounted: function () {
        if (this.$route.query.theme == "dark") {
            this.setTheme("dark");
        }
        if (this.$route.query.token) {
            this.setToken(this.$route.query.token);
        }
        this.loadData();
    },
};
</script>

<style scoped>
#app {
    background-color: #000;
}

.page-container {
    height: 100%;
    background-image: url(/img/bg_friends.6160a073.jpg);
    background-size: cover;
    background-position: center center;
    background-attachment: fixed;
    background-color: #000;
    z-index: 1;
}

.page-title {
    text-align: center;
}

.container {
    background-color: #fff;
    border-radius: 10px;
    width: calc(100% - 60px);
    margin: 30px;
    display: inline-block;
    overflow: hidden;
    height: calc(100vh - 60px);
}

.page-title {
    padding: 15px 0;
}

.users {
    padding: 20px;
}

.card {
    padding: 10px;
    box-shadow: 0px 0px 2px #888888;
    margin-bottom: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
}

.card .index {
    width: 25px;
    display: inline-block;
    font-weight: bold;
}

.card .name {
    flex: 1;
    display: flex;
    align-items: center;
}

.card .img {
    height: 18px;
    margin: 0 5px;
}

.bullet {
    border-radius: 50px;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin: 10px 2px;
}
</style>